import { helper } from '@ember/component/helper';
import { isPresent } from '@ember/utils';

import { getColorCssVar } from '../utils/style-utils';

import type { THueVariationString, TVariation } from '../utils/style-utils';
const colorVarHelper = helper(function colorVar(
  [color]: [THueVariationString | undefined],
  { variant, alpha, rgba }: { variant?: TVariation; alpha?: number; rgba?: boolean } = {}
) {
  if (!color) return undefined;
  const cssVar = getColorCssVar(color, variant, alpha);
  return isPresent(alpha) && rgba ? `rgba(${cssVar}, ${alpha})` : cssVar;
});

export default colorVarHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'color-var': typeof colorVarHelper;
  }
}
